import React from "react";
import "./CountryPicker.scss";
import ReactFlagsSelect from "react-flags-select";
import { CountrySelector } from "../../utilities/helper/CountrySelector";

interface CountryPickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  onCodeChange: (value: string) => void;
}
const CountryPicker: React.FC<CountryPickerProps> = ({
  label,
  value,
  onChange,
  required,
  onCodeChange,
}) => {
  const handleChange = (code: any) => {
    const countryName = CountrySelector[code];
    onChange(code);
    onCodeChange(countryName);
  };
  return (
    <div className='wr-input'>
      <div className='wr-input-lable'>
        {label}
        {required && <span className='req-ic'>*</span>}
      </div>
      <div className='wr-input-wrapper'>
        <ReactFlagsSelect
          selected={value}
          onSelect={handleChange}
          className='cp-input-cont'
          placeholder='Select Country'
        />
      </div>
    </div>
  );
};
export default CountryPicker;
